import { AxiosResponse } from "axios";
import { AplRole } from "../types/aplRole";
import { AplRoleFeature } from "../types/aplRoleFeature";
import { Department } from "../types/department";
import { PrinterLineSelection } from "../types/printerLineSelection";
import { UserWorkcentreRole } from "../types/userWorkcentreRole";
import { aplClient } from "./apiClient";
import { AplUser } from "../types/aplUser";
import { LineItem } from "../types/lineItem";
import { Printer } from "../types/printer";
import { AplFeature } from "../types/aplFeature";

const getPrintersLineAssignment = (siteId: number): Promise<AxiosResponse<PrinterLineSelection[]>> => {
    return aplClient().get(`admin/PrintersLineAssignment/${siteId}`);
};
const getPrintersDepartmentAssignments = (siteId: number): Promise<AxiosResponse<Department[]>> => {
    return aplClient().get(`admin/PrintersDepartmentAssignment/${siteId}`);
};
const savePrintersDepartmentAssignments = (department: Department[]): Promise<AxiosResponse> => {
    return aplClient().put(`admin/PrintersDepartmentAssignment`, department);
};
const savePrintersLineAssignments = (printerLineSelections: PrinterLineSelection[]): Promise<AxiosResponse> => {
    return aplClient().put(`admin/PrintersLineAssignment`, printerLineSelections);
};
const getUserWorkcentreRole = (userId: string): Promise<AxiosResponse<UserWorkcentreRole[]>> => {
    return aplClient().get(`admin/UserWorkcentreRole/${userId}`);
};

const saveUserWorkcentreRole = (userId: string, userWorkcentreRoles: UserWorkcentreRole[]): Promise<AxiosResponse> => {
    return aplClient().put(`admin/UserWorkcentreRole/${userId}`, userWorkcentreRoles);
};

const getAplRole = (): Promise<AxiosResponse<AplRole[]>> => {
    return aplClient().get(`admin/AplRole`);
};

const getAplFeature = (): Promise<AxiosResponse<AplFeature[]>> => {
    return aplClient().get(`admin/AplFeature`);
};

const getAplRoleFeature = (): Promise<AxiosResponse<AplRoleFeature[]>> => {
    return aplClient().get(`admin/AplRoleFeature`);
};

const saveAplRoleFeature = (roleId: number, aplRoleFeatures: AplFeature[]): Promise<AxiosResponse> => {
    return aplClient().put(`admin/AplRoleFeature/${roleId}`, aplRoleFeatures);
};

const addAplRole = (roleName: string): Promise<AxiosResponse> => {
    return aplClient().post(`admin/AplRole`, roleName);
};
const deleteRole = (roleId: number): Promise<AxiosResponse> => {
    return aplClient().delete(`admin/AplRole/${roleId}`);
};

const getUsers = (siteId: number = 0): Promise<AxiosResponse<AplUser[]>> => {
    return aplClient().get(`admin/Users/${siteId}`);
};

const getLines = (siteId: number = 0): Promise<AxiosResponse<LineItem[]>> => {
    return aplClient().get(`admin/Lines/${siteId}`);
};

const addUser = (username: string, password: string, siteId: number): Promise<AxiosResponse<AplUser>> => {
    return aplClient().post(`admin/addUser`, { username: username, password: password, siteId: siteId });
};

const changePasswordAdmin = async (userName: string, password: string, sessionDescription: string) => {
    var data = {
        username: userName,
        password: password,
        sessionDescription: sessionDescription
    };
    return aplClient().post("admin/ChangePasswordAdmin", data);
};

const getSites = async (siteId: number) => aplClient().get(`admin/sites/${siteId}`);

const getPrinters = async (siteId: number): Promise<AxiosResponse<Printer[], any>> => aplClient().get(`admin/printers/${siteId}`);

export {
    getPrintersLineAssignment,
    getPrintersDepartmentAssignments,
    savePrintersDepartmentAssignments,
    savePrintersLineAssignments,
    getUserWorkcentreRole,
    saveUserWorkcentreRole,
    getAplRole,
    getAplFeature,
    getAplRoleFeature,
    saveAplRoleFeature,
    addAplRole,
    deleteRole,
    getUsers,
    addUser,
    changePasswordAdmin,
    getSites,
    getLines,
    getPrinters
};
